import React, {useMemo} from "react";
import {useParams} from "react-router-dom";
import EntityListRowForm from "../../../../components/Entities/EntityListRowForm";
import {PublicTransitLayerEntityName} from "../../../../api/entities/replancity_PublicTransitLine";
import {EntityServiceName} from "../../../../api/enums/enums";
import EntitiesLoader from "../../../../components/Entities/EntitiesLoader/EntitiesLoader";
import CopyLineActionFabric from "../ListEntityActionCopyTo/CopyLineAction";
import {useTranslation} from "react-i18next";
import CopyRouteToLineActionFabric from "../ListEntityActionCopyTo/CopyRouteToLineAction";
import InvertRouteActionFabric from "../../../../features/public-transit/invert-route-action/ui/InvertRouteAction";
import TraceRouteToNetworkFabric from "../../../../features/trace-route-to-network/ui/TraceRouteToNetwork";


const TransitRoutesList = () => {
    const entityName = PublicTransitLayerEntityName.ROUTES;
    const serviceName = EntityServiceName.PUBLIC_TRANSIT;
    const {lineId} = useParams<any>();
    const {t} = useTranslation();

    const actions = useMemo(() => ([
        {
            label: t('transit-lines.copy-route-to-line-btn-tooltip'),
            dialogTitle: t("transit-lines.copy-route-to-line-modal-title"),
            dialogContentFabric: CopyRouteToLineActionFabric
        },
        {
            label: t('transit-lines.invert-route'),
            dialogTitle: '',
            dialogContentFabric: InvertRouteActionFabric
        },
        {
            label: t("transit-lines.trace-route-to-network-btn"),
            dialogTitle: t("transit-lines.trace-route-to-network-form-title"),
            dialogContentFabric: TraceRouteToNetworkFabric
        }
    ]), [CopyLineActionFabric, InvertRouteActionFabric, TraceRouteToNetworkFabric]);

    return (
        <EntitiesLoader
            entityName={entityName}
            layerEntityName={entityName}
            serviceName={serviceName}
            parentId={lineId}
            form={EntityListRowForm}
            menuActions={actions}
        />
    )
}

export default TransitRoutesList;